/**
 *
 */

var Height = (function($) {
  function contactFormHeight() {
    if ($(window).width() > 768) {
      var formHeight = $(".home-contact-form").outerHeight();

      $(".home-contact-wrapper").css("height", formHeight);
    } else {
      $(".home-contact-wrapper").css("height", "");
    }
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".home-contact-form").length) {
      return;
    }

    contactFormHeight();

    $(window).on("resize", function() {
      contactFormHeight();
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Height.init);
